export function getWaitFramesPromise(frameCount) {
    return new Promise((resolve) => {
        const frame = () => {
            if (frameCount === 0) {
                resolve();
            }
            frameCount--;
            requestAnimationFrame(frame);
        };
        frame();
    });
}
